import * as Yup from 'yup';
import { showWarningToast } from '../../../utils/toastHelper';
import i18next from 'i18next';
export const t = (key) => i18next.t(key, { ns: 'Inventory' });

export const inventorySchema = Yup.object().shape({
  product_id: Yup.string().required('PRODUCT_SELECTION_REQUIRED'),
  stock_in: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('STOCK_IN_REQUIRED')
    .min(0.1, 'STOCK_IN_MIN'),
});

export const validateInventory = async (data) => {
  try {
    await inventorySchema.validate(data, { abortEarly: false });
    return true;
  } catch (error) {
    //error.inner.forEach((err) => {
    //     showWarningToast(err.message);
    //    });
    if (Array.isArray(error.inner) && error.inner.length > 0) {
      const firstError = error.inner[0];
      if (firstError.message) {
        showWarningToast(t(firstError.message)); // Show the first message
      }
    }

    return false;
  }
};
